import api from "../utils/axiosConfig";

export type ChangePasswordParams = {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
};

export type ChangePasswordResponse = {
  updated: boolean;
  /** At least 1 (this session); higher means other devices were signed out too. */
  sessionsEnded: number;
};

/** `PUT /me/password`. Success ends every session on the account, this one included. */
export const changePassword = (params: ChangePasswordParams): Promise<ChangePasswordResponse> =>
  api.put<ChangePasswordResponse>("/me/password", params).then((response) => response.data);
